<template>
  <div class="grid">
    <div class="trip">
      <div class="item">
        <img
          src="@/static/images/pointsMall/icon_lucky_home_justice_tag1.png"
          alt=""
        />
        <span>100%公开</span>
      </div>
      <div class="item">
        <img
          src="@/static/images/pointsMall/icon_lucky_home_quality_tag2 (1).png"
          alt=""
        />
        <span>100%正品</span>
      </div>
      <div class="item">
        <img
          src="@/static/images/pointsMall/icon_lucky_home_quality_tag2.png"
          alt=""
        />
        <span>免费配送</span>
      </div>
    </div>
    <div class="nav">
      <!-- :to="'/pointsMall/category' + '?id=' + item.id" -->
      <div v-for="item in homeData?.menu || []" :key="item.id + 'nav'">
        <router-link
          :to="item.link_url"
          class="router"
          v-if="
            item.link_url.indexOf('http') == -1 &&
            item.link_url.indexOf('com') == -1 &&
            item.link_url.indexOf('cn') == -1
          "
        >
          <p>
            <img :src="item.icon" :alt="item.name" />
          </p>
          <p>
            {{ item.name }}
          </p>
        </router-link>
        <a :href="item.link_url" v-else class="router">
          <p>
            <img :src="item.icon" :alt="item.name" />
          </p>
          <p>
            {{ item.name }}
          </p>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "menuCom",
  props: {
    homeData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    jump(e) {
      if (e.link_url.indexOf("http") >= 0) {
        window.location = e.link_url;
      } else {
        this.$router.push({ path: e.link_url });
      }
    },
  },
};
</script>
